import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { GiFilmProjector } from "react-icons/gi";
import CountUp from 'react-countup';
import ScrollTrigger from "react-scroll-trigger";
import apiClient from "../Config/apiConfig";
import {
    FaUserTie,
    FaGlobeAmericas,
    FaPeopleArrows,
} from "react-icons/fa";
const Animatedcounter = () => {
    const [counterOn, setCounterOn] = useState(false);
    const [gethomepageData, setGethomepageData] = useState([]);
    const homepageApi = async () => {
        try {
            const res = await apiClient.get(`api/homepages`);
            setGethomepageData(res.data);
        } catch (error) {
            console.log(error.message);
        }
    };
    useEffect(() => {
        homepageApi();
    }, []);
    return (
        <>
            <Container>

                <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                    {gethomepageData && (
                        <Row>
                            <Col lg="3" md="6" sm="12">
                                <div className="inner-box">
                                    <div className="count-outer">
                                        <span> {counterOn && <CountUp
                                            start={0}
                                            end={gethomepageData.completed_project}
                                            duration={2}
                                            delay={0}
                                        />}</span>
                                    </div>
                                    <h5>Projects Completed</h5>
                                    <div className="icon-box">
                                        <GiFilmProjector />
                                    </div>
                                </div>
                            </Col>
                            <Col lg="3" md="6" sm="12">
                                <div className="inner-box">
                                    <div className="count-outer">
                                        <span>{counterOn && <CountUp
                                            start={0}
                                            end={gethomepageData.professional_staff}
                                            duration={2}
                                            delay={0}
                                        />}+</span>
                                    </div>
                                    <h5>Professional Staff</h5>
                                    <div className="icon-box">
                                        <FaUserTie />
                                    </div>
                                </div>
                            </Col>
                            <Col lg="3" md="6" sm="12">
                                <div className="inner-box">
                                    <div className="count-outer">
                                        <span>0{counterOn && <CountUp
                                            start={0}
                                            end={gethomepageData.countries_covered}
                                            duration={4}
                                            delay={0}
                                        />}</span>
                                    </div>
                                    <h5>Countries Covered</h5>
                                    <div className="icon-box">
                                        <FaGlobeAmericas />
                                    </div>
                                </div>
                            </Col>
                            <Col lg="3" md="6" sm="12">
                                <div className="inner-box">
                                    <div className="count-outer">
                                        <span>{counterOn && <CountUp
                                            start={0}
                                            end={gethomepageData.satisfied_people}
                                            duration={2}
                                            delay={0}
                                        />}</span>
                                    </div>
                                    <h5>Satisfied People</h5>
                                    <div className="icon-box">
                                        <FaPeopleArrows />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}
                </ScrollTrigger>
            </Container>
        </>
    );
};
export default Animatedcounter;